import Config from './Config';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from '@/../../app/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';
import {
  useNotificationsStore,
  HitBannerNotificationItem,
} from '../../store/pinia/notifications';
import {DataService} from '../../api/data/DataService';
import {v4 as uuidv4} from 'uuid';

export default class ReportsLayouts extends Config {
  constructor({
    id,
    label = 'report.layout',
    name = undefined,
    datatype = 'JSON',
    value = undefined,
  }) {
    super({id, label, name, datatype, value});
  }

  get fullDesignation() {
    return this.name;
  }

  static get orderKey() {
    return 'name';
  }

  static get fkName() {
    return 'name';
  }

  static get joinAttrsKey() {
    return ['name'];
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['name'], ['id', 'label', 'value']);
  }

  static get detailAttrs() {
    return this.getAttributes(['id', 'label', 'name', 'label']);
  }

  get fkName() {
    return this.name;
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'id',
        tableProperties: {
          header: 'hit-app.common.id',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'label',
        tableProperties: {
          header: 'hit-app.common.label',
          maxWidth: '1fr',
        },
        filters: {label: 'eq.report.layout'},
      }),
      new AT.StringAttribute({
        name: 'name',
        tableProperties: {
          header: 'hit-app.configuration.name',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'visible',
        tableProperties: {
          header: 'hit-app.common.visible',
        },
      }),
      new AT.BooleanAttribute({
        name: 'customisable',
        tableProperties: {
          header: 'hit-app.common.customisable',
        },
      }),
      new AT.EnumerationAttribute({
        name: 'datatype',
        enumType: 'CONFIG_DATATYPE',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-app.common.datatype',
        },
      }),
      new AT.BooleanAttribute({
        name: 'global',
        tableProperties: {
          header: 'hit-app.common.global',
        },
      }),
      new AT.JsonObjectAttribute({
        name: 'value',
      }),
    ];
  }

  // Custom methods that are grouped in the entity model to not duplicate specific methods if used in multiple screens

  /**
   * Sets the selected layout as the default print layout for the passed report
   */
  static async setAsDefault(layoutId, reportName, displayBanner = false) {
    // We can not use upsert for the config table
    await DataService.delete('config', {
      label: 'eq.report.config',
      name: `eq.${reportName}`,
    });
    if (layoutId == null) {
      return;
    }
    await DataService.upsert('config', {
      id: uuidv4(),
      label: 'report.config',
      name: reportName,
      visible: false,
      customisable: false,
      datatype: 'JSON',
      value: {
        layout_id: layoutId,
      },
      global: false,
    });
    if (displayBanner) {
      useNotificationsStore().insertBannerNotification(
        translate('hit-base.banners.set-print-config'),
        HitBannerNotificationItem.SUCCESS,
      );
    }
  }
}
